import './App.css';
import DrumContainer from './DrumContainer';

function App() {
    return (
        <DrumContainer/>
    );
}

export default App;
